import { createSelector } from 'reselect';
import { selectInstanceEditingState } from './instanceEditSelectors';
export const selectInstanceGroup = createSelector([selectInstanceEditingState], instanceEditingState => {
  if (instanceEditingState && !instanceEditingState.instanceGroup) {
    throw new Error('Initial fetch request setup is required for Instance group data.');
  }
  return instanceEditingState && instanceEditingState.instanceGroup;
});
export const selectInstanceGroupSlug = createSelector([selectInstanceGroup], instanceGroup => {
  var _instanceGroup$values;
  return (instanceGroup === null || instanceGroup === void 0 || (_instanceGroup$values = instanceGroup.values) === null || _instanceGroup$values === void 0 ? void 0 : _instanceGroup$values.hs_slug) || '';
});
export const selectInstanceGroupName = createSelector([selectInstanceGroup], instanceGroup => {
  return instanceGroup === null || instanceGroup === void 0 ? void 0 : instanceGroup.values.hs_name;
});
export const selectInstanceGroupLanguage = createSelector([selectInstanceGroup], instanceGroup => {
  return instanceGroup === null || instanceGroup === void 0 ? void 0 : instanceGroup.values.hs_language;
});